import type { ComponentProps, FC } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';

export const AddBalanceButton: FC<ComponentProps<typeof ClickableDiv>> = ({
  className,
  ...props
}) => {
  return (
    <ClickableDiv
      {...props}
      className={cn(
        'bg-back200 flex size-[26px] items-center justify-center rounded-full',
        className
      )}
    >
      <IcoMoonIcon className="text-green800 size-4" iconName="add" />
    </ClickableDiv>
  );
};
